import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Period, PresetKey, presetPeriod, quickPresets } from '../../models/time-range';
import { formatDateTime } from '../../utils/format';
import PeriodPicker from './PeriodPicker';
import SegmentedControl from './SegmentedControl';
import './RangeToolbar.scss';

interface RangeToolbarProps {
  value: Period;
  onChange: (value: Period) => void;
  first?: Date;
  last?: Date;
  count?: number;
}

const RangeToolbar = ({ value, onChange, first, last, count }: RangeToolbarProps) => {
  const { t } = useTranslation('common');
  return (
    <div className="RangeToolbar">
      <div className="RangeToolbar__controls">
        <SegmentedControl<PresetKey | 'custom'>
          variant="dark"
          label={t('range.label')}
          value={value.preset}
          onChange={(p) => p !== 'custom' && onChange(presetPeriod(p))}
          options={quickPresets.map((p) => ({ value: p, label: t(`range.${p}`) }))}
        />
        <PeriodPicker value={value} onChange={onChange} />
      </div>
      {count !== undefined && (
        <span className="RangeToolbar__summary">
          {first && last && count > 0
            ? t('range.summary', { from: formatDateTime(first), to: formatDateTime(last), count })
            : t('range.empty')}
        </span>
      )}
    </div>
  );
};

export default RangeToolbar;
